// Giveaway Wizard API Configuration
const GIVEAWAY_API_URL = 'https://giveaway-api-production-5d09.up.railway.app';

// --- Locale & Translation System ---
const WIZARD_LOCALE = (document.documentElement.lang || '').startsWith('ar') ? 'ar' : 'en';

const TR = {
  'title': { en: 'Giveaways Booking', ar: 'حجز التوزيعات' },
  'step1_subtitle': { en: 'Select the product you want to use for your giveaway.', ar: 'يرجى اختيار المنتج المراد استخدامه في التوزيعات.' },
  'step2_subtitle': { en: 'Customize your selected product by choosing quantities, variants, and sticker type.', ar: 'يمكنك تخصيص المنتج المختار من خلال تحديد الكميات، الأنواع، ونوع الملصق.' },
  'step3_subtitle': { en: 'Choose the packaging style for your giveaway.', ar: 'اختر نوع التغليف لتوزيعاتك.' },
  'step4_subtitle': { en: 'Select the occasion and customize your sleeve.', ar: 'اختر المناسبة وخصّص الغلاف.' },
  'step5_subtitle': { en: 'Fill in your details so our team can prepare and confirm your booking.', ar: 'يرجى إدخال بياناتك ليتمكّن فريقنا من تجهيز الطلب وتأكيد الحجز.' },
  'eau-de-parfum': { en: 'Eau De Parfum', ar: 'أو دو بارفان' },
  'home-spray': { en: 'Home Spray', ar: 'بخاخات المنزل' },
  'select_scents': { en: 'Select Scents', ar: 'اختر العطر' },
  'amalfi-waves': { en: 'Amalfi Waves', ar: 'أمالفي ويفز' },
  'alpine-mist': { en: 'Alpine Mist', ar: 'ألباين ميست' },
  'amazonian-rain': { en: 'Amazonian Rain', ar: 'أمازونيان رين' },
  'andalusian-hide': { en: 'Andalusian Hide', ar: 'أندلسيان هايد' },
  'atlas-peaks': { en: 'Atlas Peaks', ar: 'أتلس بيكس' },
  'california-gold': { en: 'California Gold', ar: 'كاليفورنيا جولد' },
  'desert-nights': { en: 'Desert Nights', ar: 'ديزرت نايتس' },
  'nordic-frost': { en: 'Nordic Frost', ar: 'نوردك فروست' },
  'provence-breeze': { en: 'Provence Breeze', ar: 'بروفانس بريز' },
  'sakura-blossom': { en: 'Sakura Blossom', ar: 'ساكورا بلوسوم' },
  'spice-bazaar': { en: 'Spice Bazaar', ar: 'سبايس بازار' },
  'tuscan-grove': { en: 'Tuscan Grove', ar: 'توسكان جروف' },
  'tropical-gardens': { en: 'Tropical Gardens', ar: 'تروبيكال جاردنز' },
  'your_products': { en: 'Your Products', ar: 'قائمة منتجاتك' },
  'add_product': { en: 'Add a Product', ar: 'إضافة منتج' },
  'total_price': { en: 'Total Price', ar: 'السعر الإجمالي' },
  'sticker_type': { en: 'Sticker Type', ar: 'نوع الملصق' },
  'original': { en: 'Original', ar: 'تصميم أساسي' },
  'custom': { en: 'Custom', ar: 'تصميم مخصّص' },
  'customize': { en: 'Customize', ar: 'تخصيص' },
  'continue': { en: 'Continue', ar: 'المتابعة' },
  'quantity': { en: 'Quantity', ar: 'الكمية' },
  'saved': { en: 'Saved!', ar: 'تم الحفظ!' },
  'select_occasion': { en: 'Select your occasion', ar: 'اختر المناسبة' },
  // Updated occasion translations
  'baby_boy': { en: 'Baby Boy', ar: 'مولود' },
  'baby_girl': { en: 'Baby Girl', ar: 'مولودة' },
  'eid': { en: 'Eid', ar: 'عيد' },
  'graduation': { en: 'Graduation', ar: 'تخرّج' },
  'marriage': { en: 'Marriage', ar: 'زواج' },
  'gratitude': { en: 'Gratitude', ar: 'شكر وامتنان' },
  'custom_occasion': { en: 'Custom', ar: 'مخصّص' },
  'bag': { en: 'Bag', ar: 'كيس هدايا' },
  'box_1': { en: 'Box 1', ar: 'علبة هدايا ١' },
  'box_2': { en: 'Box 2', ar: 'علبة هدايا ٢' },
  'custom_package': { en: 'Custom Package', ar: 'تغليف مخصّص' },
  'custom_package_text_label': { en: 'Describe your custom packaging', ar: 'صف التغليف المخصّص' },
  'custom_package_placeholder': { en: 'e.g. White ribbon box with gold foil...', ar: 'مثال: علبة بيضاء مع شريط ذهبي...' },
  'custom_package_action': { en: 'Configure Packaging', ar: 'تخصيص التغليف' },
  'fill_form': { en: 'Fill Form', ar: 'تعبئة النموذج' },
  'form_instruction': { en: 'Complete the form to create a new booking', ar: 'أكمل النموذج لإنشاء حجز جديد' },
  'name_label': { en: 'Name*', ar: 'الاسم*' },
  'name_placeholder': { en: 'Customer Name', ar: 'اسم العميل' },
  'phone_label': { en: 'Phone Number*', ar: 'رقم الهاتف*' },
  'email_label': { en: 'Email*', ar: 'البريد الإلكتروني*' },
  'email_placeholder': { en: 'email@example.com', ar: 'email@example.com' },
  'address_label': { en: 'Delivery Address*', ar: 'عنوان التوصيل*' },
  'address_placeholder': { en: 'Complete Address', ar: 'العنوان الكامل' },
  'date_label': { en: 'Delivery Date*', ar: 'تاريخ التوصيل*' },
  'store_label': { en: 'Store*', ar: 'الفرع*' },
  'select_store': { en: 'Select Store', ar: 'اختر الفرع' },
  'create_booking': { en: 'Create Booking', ar: 'إنشاء حجز' },
  'submitting': { en: 'Submitting...', ar: 'جارٍ الإرسال...' },
  'err_name': { en: 'Please enter your name', ar: 'يرجى إدخال الاسم' },
  'err_email': { en: 'Please enter a valid email address', ar: 'يرجى إدخال بريد إلكتروني صحيح' },
  'err_phone': { en: 'Please enter a valid phone number', ar: 'يرجى إدخال رقم هاتف صحيح' },
  'err_address': { en: 'Please enter a delivery address', ar: 'يرجى إدخال عنوان التوصيل' },
  'err_date': { en: 'Please select a delivery date', ar: 'يرجى اختيار تاريخ التوصيل' },
  'err_store': { en: 'Please select a store', ar: 'يرجى اختيار الفرع' },
  'err_select_product': { en: 'Please select at least one product before continuing.', ar: 'يرجى اختيار منتج واحد على الأقل قبل المتابعة.' },
  'err_fix_errors': { en: 'Please fix the following errors:\n\n', ar: 'يرجى تصحيح الأخطاء التالية:\n\n' },
  'err_submit': { en: 'Sorry, there was an error submitting your booking. Please try again.', ar: 'عذرًا، حدث خطأ أثناء إرسال الحجز. يرجى المحاولة مرة أخرى.' },
  'err_product_filter': { en: 'Sorry, only Eau De Parfum and Home Spray can be ordered through giveaways at this time.', ar: 'عذرًا، يمكن طلب أو دو بارفان وبخاخات المنزل فقط عبر التوزيعات حاليًا.' },
  'no_products': { en: 'No products selected', ar: 'لم يتم اختيار أي منتج' },
  'success_title': { en: 'Booking Submitted Successfully!', ar: 'تم إرسال الحجز بنجاح!' },
  'success_body': { en: 'Your giveaway booking has been created.', ar: 'تم إنشاء حجز التوزيعات بنجاح.' },
  'booking_id': { en: 'Booking ID:', ar: 'رقم الحجز:' },
  'save_id': { en: 'Please save this ID for your reference.', ar: 'يرجى الاحتفاظ برقم الحجز للرجوع إليه لاحقًا.' },
  'close': { en: 'Close', ar: 'إغلاق' },
  'add_product_modal': { en: 'Add a Product', ar: 'إضافة منتج' },
  'select_product': { en: 'Select Product', ar: 'اختر المنتج' },
  'cancel': { en: 'Cancel', ar: 'إلغاء' },
  'add': { en: 'Add Product', ar: 'إضافة المنتج' },
  'err_name_hint': { en: 'Please enter your full name (at least 2 characters)', ar: 'يرجى إدخال الاسم الكامل (حرفان على الأقل)' },
  'err_phone_hint': { en: 'Please enter a valid phone number (at least 8 digits)', ar: 'يرجى إدخال رقم هاتف صحيح (8 أرقام على الأقل)' },
  'err_email_hint': { en: 'Please enter a valid email address', ar: 'يرجى إدخال بريد إلكتروني صحيح' },
  'err_address_hint': { en: 'Please enter a complete delivery address', ar: 'يرجى إدخال عنوان التوصيل الكامل' },
  'err_date_hint': { en: 'Please select a delivery date', ar: 'يرجى اختيار تاريخ التوصيل' },
  'err_store_hint': { en: 'Please select a store', ar: 'يرجى اختيار الفرع' },
  'back': { en: '← Back', ar: 'رجوع ←' },
  // Sleeve
  'sleeve_designs': { en: 'Choose a Design', ar: 'اختر تصميمًا' },
  'sleeve_design': { en: 'Design', ar: 'تصميم' },
  'sleeve_custom_text_label': { en: 'Personalization Text', ar: 'نص التخصيص' },
  'sleeve_custom_text_placeholder': { en: 'e.g. Happy Birthday Sara!', ar: 'مثال: عيد ميلاد سعيد يا سارة!' },
  'sleeve_custom_save': { en: 'Save', ar: 'حفظ' },
  'sleeve_custom_saved': { en: 'Saved!', ar: 'تم الحفظ!' },
  'sleeve_upload_required': { en: 'Please upload a sleeve image for your custom occasion.', ar: 'يرجى رفع صورة للغلاف للمناسبة المخصّصة.' },
  'sleeve_text_required': { en: 'Please enter personalization text for your custom sleeve.', ar: 'يرجى إدخال نص التخصيص للغلاف.' },
  'sleeve_or_upload': { en: 'or upload your own', ar: 'أو ارفع تصميمك' },
  'design_1': { en: 'Design 1', ar: 'تصميم ١' },
  'design_2': { en: 'Design 2', ar: 'تصميم ٢' },
  'design_3': { en: 'Design 3', ar: 'تصميم ٣' },
  'upload_design': { en: 'Upload Your Design', ar: 'ارفع تصميمك' },
  'remove': { en: '✕ Remove', ar: '✕ إزالة' },
  'sleeve_preview': { en: 'Sleeve Preview', ar: 'معاينة الغلاف' },
};

function t(key) {
  const entry = TR[key];
  if (!entry) return key;
  return entry[WIZARD_LOCALE] || entry.en || key;
}

const STEP_SUBTITLES = {
  1: t('step1_subtitle'),
  2: t('step2_subtitle'),
  3: t('step3_subtitle'),
  4: t('step4_subtitle'),
  5: t('step5_subtitle')
};

const STORE_LOCATIONS = {
  kuwait: {
    label: 'Kuwait', labelAr: 'الكويت',
    stores: [
      { value: 'kuwait-online', label: 'Online', labelAr: 'أونلاين' },
      { value: 'kuwait-homz-mall', label: 'Homz Mall', labelAr: 'هومز مول' },
      { value: 'kuwait-avenues-mall-phase-3', label: 'Avenues Mall - Phase 3', labelAr: 'الأفنيوز – المرحلة الثالثة' },
      { value: 'kuwait-assima-mall', label: 'Assima Mall', labelAr: 'العاصمة مول' },
      { value: 'kuwait-al-hamra-tower', label: 'Al Hamra Tower', labelAr: 'برج الحمرا' },
      { value: 'kuwait-avenues-mall', label: 'Avenues Mall', labelAr: 'الأفنيوز' },
      { value: 'kuwait-360-mall', label: '360 Mall', labelAr: 'مول 360' },
      { value: 'kuwait-sharq', label: 'Sharq', labelAr: 'شرق' },
      { value: 'kuwait-al-salam-hospital', label: 'Al Salam Hospital', labelAr: 'مستشفى السلام' },
      { value: 'kuwait-khiran-mall', label: 'Khiran Mall', labelAr: 'الخيران مول' },
      { value: 'kuwait-marina-mall', label: 'Marina Mall', labelAr: 'مارينا مول' },
      { value: 'kuwait-international-hospital', label: 'International Hospital', labelAr: 'المستشفى الدولي' },
      { value: 'kuwait-warehouse-mall', label: 'The Warehouse Mall', labelAr: 'ذا وير هاوس مول' }
    ]
  },
  uae: {
    label: 'UAE', labelAr: 'الإمارات',
    stores: [
      { value: 'uae-online', label: 'Online', labelAr: 'أونلاين' },
      { value: 'uae-marina-mall-abudhabi', label: 'Marina Mall – Abu Dhabi', labelAr: 'مارينا مول – أبو ظبي' },
      { value: 'uae-galleria-mall-abudhabi', label: 'Galleria Mall – Abu Dhabi', labelAr: 'جاليريا مول – أبو ظبي' },
      { value: 'uae-yas-mall-abudhabi', label: 'Yas Mall – Abu Dhabi', labelAr: 'ياس مول – أبو ظبي' },
      { value: 'uae-arabian-centre-dubai', label: 'Arabian Centre – Dubai', labelAr: 'أرابيان سنتر – دبي' },
      { value: 'uae-al-hamra-mall-rak', label: 'Al Hamra Mall – Ras Al Khaima', labelAr: 'الحمرا مول – رأس الخيمة' }
    ]
  },
  ksa: {
    label: 'KSA', labelAr: 'السعودية',
    stores: [{ value: 'ksa-online', label: 'Online', labelAr: 'أونلاين' }]
  },
  oman: {
    label: 'Oman', labelAr: 'عمان',
    stores: [{ value: 'oman-online', label: 'Online', labelAr: 'أونلاين' }]
  },
  qatar: {
    label: 'Qatar', labelAr: 'قطر',
    stores: [
      { value: 'qatar-online', label: 'Online', labelAr: 'أونلاين' },
      { value: 'qatar-tawar-mall', label: 'Tawar Mall', labelAr: 'طوار مول' },
      { value: 'qatar-al-sadd-branch', label: 'Al-Sadd Branch', labelAr: 'شارع السد' },
      { value: 'qatar-vendome-place-mall', label: 'Vendome Place Mall', labelAr: 'الفاندوم' }
    ]
  },
  bahrain: {
    label: 'Bahrain', labelAr: 'البحرين',
    stores: [
      { value: 'bahrain-online', label: 'Online', labelAr: 'أونلاين' },
      { value: 'bahrain-city-center', label: 'Bahrain City Center', labelAr: 'سيتي سنتر البحرين' },
      { value: 'bahrain-enma-mall', label: 'Enma Mall', labelAr: 'إنماء مول' }
    ]
  }
};

const PRODUCTS_DATA = [
  {
    handle: 'eau-de-parfum',
    title: 'Eau De Parfum',
    image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/EauDeParfum.png?v=1767725050',
    customLabelImage: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/mockups_0a353cfc-ad57-4ac7-b79e-79a494b6035f.png?v=1770148094',
    alt: 'Eau De Parfum',
    variantLabel: 'Select Scents',
    supportsCustomSticker: true,
    safeZone: { centerX: 0.5569, centerY: 0.6628, width: 0.4388, height: 0.3285, rotation: -Math.PI/2, textColor: '#D4200B', fontFamily: 'Arial, Helvetica, sans-serif' },
    variants: [
      { value: 'amalfi-waves', label: 'Amalfi Waves', sku: '102253' },
      { value: 'alpine-mist', label: 'Alpine Mist', sku: '102255' },
      { value: 'amazonian-rain', label: 'Amazonian Rain', sku: '102245' },
      { value: 'andalusian-hide', label: 'Andalusian Hide', sku: '102248' },
      { value: 'atlas-peaks', label: 'Atlas Peaks', sku: '102252' },
      { value: 'california-gold', label: 'California Gold', sku: '102256' },
      { value: 'desert-nights', label: 'Desert Nights', sku: '102246' },
      { value: 'nordic-frost', label: 'Nordic Frost', sku: '102250' },
      { value: 'provence-breeze', label: 'Provence Breeze', sku: '102249' },
      { value: 'sakura-blossom', label: 'Sakura Blossom', sku: '102251' },
      { value: 'spice-bazaar', label: 'Spice Bazaar', sku: '102254' },
      { value: 'tuscan-grove', label: 'Tuscan Grove', sku: '102247' }
    ]
  },
  {
    handle: 'home-spray',
    title: 'Home Spray',
    image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/HomeSpray.png?v=1770144260',
    customLabelImage: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/mockups.png?v=1770148162',
    alt: 'Home Spray',
    variantLabel: 'Select Scents',
    supportsCustomSticker: true,
    safeZone: { centerX: 0.4594, centerY: 0.7279, width: 0.2810, height: 0.2184, rotation: -Math.PI/2, textColor: '#D4200B', fontFamily: 'Arial, Helvetica, sans-serif' },
    variants: [
      { value: 'amalfi-waves', label: 'Amalfi Waves', sku: '102421' },
      { value: 'alpine-mist', label: 'Alpine Mist', sku: '102422' },
      { value: 'amazonian-rain', label: 'Amazonian Rain', sku: '102204' },
      { value: 'andalusian-hide', label: 'Andalusian Hide', sku: '102208' },
      { value: 'atlas-peaks', label: 'Atlas Peaks', sku: '102420' },
      { value: 'california-gold', label: 'California Gold', sku: '102205' },
      { value: 'desert-nights', label: 'Desert Nights', sku: '102206' },
      { value: 'nordic-frost', label: 'Nordic Frost', sku: '102210' },
      { value: 'provence-breeze', label: 'Provence Breeze', sku: '102209' },
      { value: 'sakura-blossom', label: 'Sakura Blossom', sku: '102211' },
      { value: 'spice-bazaar', label: 'Spice Bazaar', sku: '102419' },
      { value: 'tropical-gardens', label: 'Tropical Gardens', sku: '102435' },
      { value: 'tuscan-grove', label: 'Tuscan Grove', sku: '102207' }
    ]
  }
];

// ==========================================
// UPDATED OCCASION → PACKAGE MAPPING
// ==========================================
const OCCASION_PACKAGES = {
  'baby_boy':        ['box_1', 'box_2', 'bag'],
  'baby_girl':       ['box_1', 'box_2', 'bag'],
  'eid':             ['bag', 'box_1', 'box_2'],
  'graduation':      ['box_1', 'box_2', 'bag'],
  'marriage':        ['box_2', 'box_1', 'bag'],
  'gratitude':       ['bag', 'box_1', 'box_2'],
  'custom_occasion': []
};

const PACKAGES_DATA = [
  { handle: 'bag',   titleKey: 'bag',   image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/Bag.jpg?v=1770141795',   alt: 'Bag'   },
  { handle: 'box_1', titleKey: 'box_1', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/Box-1.jpg?v=1770141795', alt: 'Box 1' },
  { handle: 'box_2', titleKey: 'box_2', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/Box-2.jpg?v=1770141795', alt: 'Box 2' }
];

// ==========================================
// UPDATED OCCASIONS LIST
// ==========================================
const OCCASIONS_LIST = [
  { value: 'baby_boy',        labelKey: 'baby_boy'        },
  { value: 'baby_girl',       labelKey: 'baby_girl'       },
  { value: 'eid',             labelKey: 'eid'             },
  { value: 'graduation',      labelKey: 'graduation'      },
  { value: 'marriage',        labelKey: 'marriage'        },
  { value: 'gratitude',       labelKey: 'gratitude'       },
  { value: 'custom_occasion', labelKey: 'custom_occasion' }
];

// ==========================================
// UPDATED SLEEVE DESIGNS PER OCCASION
// 3 designs per occasion. Image URLs left empty — replace with your own CDN links.
// ==========================================
const SLEEVE_DESIGNS = {
  default: [
    { id: 'default-1', labelKey: 'design_1', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/grad1.jpg?v=1776085831' },
    { id: 'default-2', labelKey: 'design_2', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/marr2.jpg?v=1776085832' },
    { id: 'default-3', labelKey: 'design_3', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/thank3.jpg?v=1776085833' },
  ],
  baby_boy: [
    { id: 'baby-boy-1', labelKey: 'design_1', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/babyb1.jpg?v=1776085833' },
    { id: 'baby-boy-2', labelKey: 'design_2', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/babyb2.jpg?v=1776085833' },
    { id: 'baby-boy-3', labelKey: 'design_3', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/babyb3.jpg?v=1776085833' },
  ],
  baby_girl: [
    { id: 'baby-girl-1', labelKey: 'design_1', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/babyg1.jpg?v=1776085833' },
    { id: 'baby-girl-2', labelKey: 'design_2', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/babyg2.jpg?v=1776085833' },
    { id: 'baby-girl-3', labelKey: 'design_3', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/babyg3.jpg?v=1776085833' },
  ],
  eid: [
    { id: 'eid-1', labelKey: 'design_1', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/eid1.jpg?v=1776085833' },
    { id: 'eid-2', labelKey: 'design_2', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/eid2.jpg?v=1776085833' },
    { id: 'eid-3', labelKey: 'design_3', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/eid3.jpg?v=1776085832' },
  ],
  graduation: [
    { id: 'graduation-1', labelKey: 'design_1', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/grad1.jpg?v=1776085831' },
    { id: 'graduation-2', labelKey: 'design_2', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/grad2.jpg?v=1776085832' },
    { id: 'graduation-3', labelKey: 'design_3', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/grad3.jpg?v=1776085833' },
  ],
  marriage: [
    { id: 'marriage-1', labelKey: 'design_1', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/marr1.jpg?v=1776085833' },
    { id: 'marriage-2', labelKey: 'design_2', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/marr2.jpg?v=1776085832' },
    { id: 'marriage-3', labelKey: 'design_3', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/marr3.jpg?v=1776085832' },
  ],
  gratitude: [
    { id: 'gratitude-1', labelKey: 'design_1', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/thank1.jpg?v=1776085832' },
    { id: 'gratitude-2', labelKey: 'design_2', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/thank2.jpg?v=1776085833' },
    { id: 'gratitude-3', labelKey: 'design_3', image: 'https://cdn.shopify.com/s/files/1/0680/3541/2253/files/thank3.jpg?v=1776085833' },
  ],
};

const PRICING_TIERS = {
  'eau-de-parfum': [
    { min: 10,  max: 79,       price: 4.7  },
    { min: 80,  max: 119,      price: 4.1  },
    { min: 120, max: 199,      price: 3.9  },
    { min: 200, max: 499,      price: 3.5  },
    { min: 500, max: Infinity, price: 3.3  }
  ],
  'home-spray': [
    { min: 10,  max: 24,       price: 5.0  },
    { min: 25,  max: 79,       price: 4.2  },
    { min: 80,  max: 119,      price: 3.7  },
    { min: 120, max: 199,      price: 3.4  },
    { min: 200, max: 499,      price: 3.0  },
    { min: 500, max: Infinity, price: 2.75 }
  ]
};

function getUnitPrice(productHandle, quantity) {
  const tiers = PRICING_TIERS[productHandle];
  if (!tiers) return null;
  const tier = tiers.find(t => quantity >= t.min && quantity <= t.max);
  return tier ? tier.price : null;
}

function getCurrentRegion() {
  if (typeof Shopify !== 'undefined' && Shopify.country) {
    const m = { KW: 'kuwait', AE: 'uae', SA: 'ksa', OM: 'oman', QA: 'qatar', BH: 'bahrain' };
    return m[Shopify.country] || 'kuwait';
  }
  const r = new URLSearchParams(window.location.search).get('region');
  return (r && STORE_LOCATIONS[r]) ? r : 'kuwait';
}

function getCurrentLanguage() {
  if (typeof Shopify !== 'undefined' && Shopify.locale) return Shopify.locale.startsWith('ar') ? 'ar' : 'en';
  return document.documentElement.lang?.startsWith('ar') ? 'ar' : 'en';
}

function populateStoreDropdown(sel) {
  const region = getCurrentRegion(), lang = getCurrentLanguage();
  sel.innerHTML = `<option value="" disabled selected>${t('select_store')}</option>`;
  (STORE_LOCATIONS[region]?.stores || []).forEach(s => {
    const o = document.createElement('option');
    o.value = s.value;
    o.textContent = lang === 'ar' ? s.labelAr : s.label;
    sel.appendChild(o);
  });
}

// ==========================================
// IMAGE VALIDATION
// ==========================================

const IMAGE_VALIDATION = {
  maxBytes: 8 * 1024 * 1024,        // 8 MB
  minBytes: 100,                     // anything smaller is junk
  maxDimension: 6000,                // px — guards against decompression bombs
  minDimension: 50,                  // px — too small to be a real sleeve
  allowedMimes: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
  // SVG intentionally excluded — can carry scripts. Add only if you sanitize.
};

// Magic byte signatures. We read the first 12 bytes and check the prefix.
const MAGIC_BYTES = [
  { mime: 'image/jpeg', bytes: [0xFF, 0xD8, 0xFF] },
  { mime: 'image/png',  bytes: [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A] },
  { mime: 'image/gif',  bytes: [0x47, 0x49, 0x46, 0x38] }, // GIF8
  // WebP: "RIFF" .... "WEBP"
  { mime: 'image/webp', bytes: [0x52, 0x49, 0x46, 0x46], tail: { offset: 8, bytes: [0x57, 0x45, 0x42, 0x50] } },
];

function readFileHeader(file, byteCount = 12) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(new Uint8Array(reader.result));
    reader.onerror = () => reject(new Error('Could not read file'));
    reader.readAsArrayBuffer(file.slice(0, byteCount));
  });
}

function matchesSignature(header, sig) {
  for (let i = 0; i < sig.bytes.length; i++) {
    if (header[i] !== sig.bytes[i]) return false;
  }
  if (sig.tail) {
    for (let i = 0; i < sig.tail.bytes.length; i++) {
      if (header[sig.tail.offset + i] !== sig.tail.bytes[i]) return false;
    }
  }
  return true;
}

async function detectImageMime(file) {
  const header = await readFileHeader(file, 12);
  const match = MAGIC_BYTES.find(sig => matchesSignature(header, sig));
  return match ? match.mime : null;
}

function decodeAsImage(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('decode_failed'));
    img.src = dataUrl;
  });
}

/**
 * Validates a File and returns { ok, dataUrl, width, height } or { ok: false, code, message }.
 * Codes: empty, too_small, too_large, wrong_mime, signature_mismatch,
 *        decode_failed, dimensions_too_small, dimensions_too_large
 */
async function validateImageFile(file) {
  // 1. Existence & size
  if (!file) return { ok: false, code: 'empty', message: 'No file selected.' };
  if (file.size < IMAGE_VALIDATION.minBytes)
    return { ok: false, code: 'too_small', message: 'File is too small to be a valid image.' };
  if (file.size > IMAGE_VALIDATION.maxBytes)
    return { ok: false, code: 'too_large',
             message: `Image is too large. Max ${IMAGE_VALIDATION.maxBytes / 1024 / 1024} MB.` };

  // 2. Browser-reported MIME (cheap first filter)
  if (file.type && !IMAGE_VALIDATION.allowedMimes.includes(file.type))
    return { ok: false, code: 'wrong_mime',
             message: 'Only JPEG, PNG, WebP, or GIF images are allowed.' };

  // 3. Magic bytes (catches renamed files)
  let detectedMime;
  try {
    detectedMime = await detectImageMime(file);
  } catch (e) {
    return { ok: false, code: 'read_error', message: 'Could not read the file.' };
  }
  if (!detectedMime || !IMAGE_VALIDATION.allowedMimes.includes(detectedMime))
    return { ok: false, code: 'signature_mismatch',
             message: 'This file is not a real image, even if it has an image extension.' };

  // 4. Cross-check: declared MIME and actual MIME should agree
  //    (catches a PNG renamed to .jpg — minor, but worth flagging)
  if (file.type && file.type !== detectedMime) {
    // Allow jpeg/jpg variations; otherwise reject
    return { ok: false, code: 'signature_mismatch',
             message: 'File extension does not match the actual image format.' };
  }

  // 5. Read as data URL & decode test (catches corrupt files)
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload  = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('read_error'));
    reader.readAsDataURL(file);
  }).catch(() => null);

  if (!dataUrl)
    return { ok: false, code: 'read_error', message: 'Could not read the file.' };

  let img;
  try {
    img = await decodeAsImage(dataUrl);
  } catch {
    return { ok: false, code: 'decode_failed',
             message: 'The image is corrupt or could not be decoded.' };
  }

  // 6. Dimension sanity
  if (img.naturalWidth < IMAGE_VALIDATION.minDimension ||
      img.naturalHeight < IMAGE_VALIDATION.minDimension)
    return { ok: false, code: 'dimensions_too_small',
             message: `Image must be at least ${IMAGE_VALIDATION.minDimension}×${IMAGE_VALIDATION.minDimension}px.` };

  if (img.naturalWidth > IMAGE_VALIDATION.maxDimension ||
      img.naturalHeight > IMAGE_VALIDATION.maxDimension)
    return { ok: false, code: 'dimensions_too_large',
             message: `Image dimensions exceed ${IMAGE_VALIDATION.maxDimension}px.` };

  return {
    ok: true,
    dataUrl,
    width: img.naturalWidth,
    height: img.naturalHeight,
    mime: detectedMime,
    sizeBytes: file.size
  };
}

// ==========================================
// GIVEAWAY WIZARD CLASS
// ==========================================
class GiveawayWizard {
  constructor(container) {
    this.container = container;
    this.state = {
      selectedProducts: [],
      selectedPackage: null,
      selectedOccasion: null,
      selectedOccasionLabel: null,
      customPackageText: '',
      selectedSleeveDesignId: null,
      sleeveImage: null,
      sleeveCustomText: '',
      currentStep: 1,
      sliderIndex: 0,
      packageCarouselIndex: 0,
      isSubmitting: false,
      currentCustomProductIndex: 0
    };

    this.sliderGrid  = this.container.querySelector('.product-grid');
    this.prevButton  = this.container.querySelector('.slider-prev');
    this.nextButton  = this.container.querySelector('.slider-next');
    this.continueButton = this.container.querySelector('.wizard-continue');

    this.init();
  }

init() {
  this.applyTranslations();
  this.loadState();
  this.renderProducts();
  this.renderPackages();
  this.populateOccasionDropdown();
  const storeSelect = this.container.querySelector('#delivery-store');
  if (storeSelect) populateStoreDropdown(storeSelect);
  this.attachEventListeners();
  this.restoreUI();
  this.goToStep(this.state.currentStep || 1);
  this.updateSliderButtons();
  this.updateContinueButton();
}

  applyTranslations() {
    if (WIZARD_LOCALE === 'ar') this.container.setAttribute('dir', 'rtl');
    const set = (sel, txt) => { const el = this.container.querySelector(sel); if (el) el.textContent = txt; };
    set('.wizard-title',         t('title'));
    set('.wizard-subtitle',      t('step1_subtitle'));
    set('.wizard-back',          t('back'));
    set('.customization-header', t('your_products'));
    set('.sticker-type-header',  t('sticker_type'));
    set('.sticker-type-btn[data-type="original"]', t('original'));
    set('.sticker-type-btn[data-type="custom"]',   t('custom'));
    set('.sticker-customize-btn', t('customize'));
    set('.form-instruction',      t('form_instruction'));
    set('label[for="customer-name"]', t('name_label'));
    set('label[for="phone-number"]',  t('phone_label'));
    set('label[for="email"]',         t('email_label'));
    set('label[for="delivery-address"]', t('address_label'));
    set('label[for="delivery-date"]',    t('date_label'));
    set('label[for="delivery-store"]',   t('store_label'));
    set('.wizard-submit', t('create_booking'));
    set('.sleeve-upload-btn-text', t('upload_design'));
    set('.sleeve-card-label', t('sleeve_preview'));

    const continueBtns = this.container.querySelectorAll('.wizard-continue');
    continueBtns.forEach(btn => {
      btn.textContent = btn.dataset.nextStep === '5' ? t('fill_form') : t('continue');
    });

    const addProductBtn = this.container.querySelector('.add-product-btn');
    if (addProductBtn) {
      const svg = addProductBtn.querySelector('svg');
      addProductBtn.textContent = '';
      if (svg) addProductBtn.appendChild(svg);
      addProductBtn.appendChild(document.createTextNode(' ' + t('add_product')));
    }

    const priceSummary = this.container.querySelector('.price-summary');
    if (priceSummary) {
      const lbl = priceSummary.querySelector('span:first-child');
      if (lbl) lbl.textContent = t('total_price');
    }

    const setPlaceholder = (sel, txt) => { const el = this.container.querySelector(sel); if (el) el.placeholder = txt; };
    setPlaceholder('#customer-name',    t('name_placeholder'));
    setPlaceholder('#email',            t('email_placeholder'));
    setPlaceholder('#delivery-address', t('address_placeholder'));

    const storeSelect = this.container.querySelector('#delivery-store');
    if (storeSelect) {
      const def = storeSelect.querySelector('option[disabled]');
      if (def) def.textContent = t('select_store');
    }

    this.container.querySelectorAll('.form-group').forEach(group => {
      const lbl = group.querySelector('label');
      const err = group.querySelector('.error-message');
      if (!lbl || !err) return;
      const map = {
        'customer-name': 'err_name_hint', 'phone-number': 'err_phone_hint',
        'email': 'err_email_hint', 'delivery-address': 'err_address_hint',
        'delivery-date': 'err_date_hint', 'delivery-store': 'err_store_hint'
      };
      const key = map[lbl.getAttribute('for')];
      if (key) err.textContent = t(key);
    });

    const bookingModal = document.getElementById('bookingModal');
    if (bookingModal) {
      const h2 = bookingModal.querySelector('.modal-body h2');
      if (h2) h2.textContent = t('success_title');
      const p  = bookingModal.querySelector('.modal-body p');
      if (p)  p.textContent  = t('success_body');
      const btn = bookingModal.querySelector('.modal-body .modal-btn');
      if (btn) btn.textContent = t('close');
    }

    const addModal = document.getElementById('addProductModal');
    if (addModal) {
      const h2  = addModal.querySelector('.modal-body h2');         if (h2)  h2.textContent  = t('add_product_modal');
      const lbl = addModal.querySelector('.modal-product-label');   if (lbl) lbl.textContent = t('select_product');
      const can = addModal.querySelector('.modal-cancel-btn');      if (can) can.textContent = t('cancel');
      const add = addModal.querySelector('.modal-add-btn');         if (add) add.textContent = t('add');
    }
  }

  saveState() {
    try {
      localStorage.setItem('giveawayWizardState', JSON.stringify({
        selectedProducts:       this.state.selectedProducts,
        selectedPackage:        this.state.selectedPackage,
        selectedOccasion:       this.state.selectedOccasion,
        selectedOccasionLabel:  this.state.selectedOccasionLabel,
        customPackageText:      this.state.customPackageText,
        selectedSleeveDesignId: this.state.selectedSleeveDesignId,
        sleeveImage:            this.state.sleeveImage,
        sleeveCustomText:       this.state.sleeveCustomText,
        currentStep:            this.state.currentStep,
        currentCustomProductIndex: this.state.currentCustomProductIndex
      }));
    } catch (e) { console.error('Failed to save state:', e); }
  }

  loadState() {
    try {
      const raw = localStorage.getItem('giveawayWizardState');
      if (!raw) return;
      const p = JSON.parse(raw);
      this.state.selectedProducts = (p.selectedProducts || []).filter(prod => {
        const pd = PRODUCTS_DATA.find(x => x.handle === prod.handle);
        if (!pd) return false;
        prod.variants = (prod.variants || []).filter(v => pd.variants.find(x => x.value === v.value));
        return true;
      });
      this.state.selectedPackage        = p.selectedPackage        || null;
      this.state.selectedOccasion       = p.selectedOccasion       || null;
      this.state.selectedOccasionLabel  = p.selectedOccasionLabel  || null;
      this.state.customPackageText      = p.customPackageText      || '';
      this.state.selectedSleeveDesignId = p.selectedSleeveDesignId || null;
      this.state.sleeveImage            = p.sleeveImage            || null;
      this.state.sleeveCustomText       = p.sleeveCustomText       || '';
      this.state.currentStep            = p.currentStep            || 1;
      this.state.currentCustomProductIndex = p.currentCustomProductIndex || 0;
      this.restoreUI();
    } catch (e) { console.error('Failed to load state:', e); }
  }

restoreUI() {
  this.state.selectedProducts.forEach(prod => {
    const card = this.container.querySelector(`[data-product-handle="${prod.handle}"]`);
    if (card) {
      const cb = card.querySelector('.product-checkbox');
      if (cb) {
        cb.checked = true;
        card.classList.add('selected');
      }
    }
  });

  if (this.state.currentStep >= 2 && this.state.selectedProducts.length > 0) {
    this.renderSelectedProducts();
  }
}

  clearState() {
    try { localStorage.removeItem('giveawayWizardState'); } catch (e) {}
  }

  renderProducts() {
    if (!this.sliderGrid) return;
    this.sliderGrid.innerHTML = '';
    PRODUCTS_DATA.forEach(product => {
      const card = document.createElement('div');
      card.className = 'product-card';
      card.setAttribute('data-product-handle', product.handle);
      card.innerHTML = `
        <img class="product-image" src="${product.image}" alt="${t(product.handle)}" width="500" height="500">
        <input type="checkbox" class="product-checkbox">
        <p class="product-title">${t(product.handle)}</p>
      `;
      this.sliderGrid.appendChild(card);
    });
  }

  renderPackages() {
    const grid = this.container.querySelector('.package-grid');
    if (!grid) return;
    grid.innerHTML = '';
    PACKAGES_DATA.forEach(pkg => {
      const card = document.createElement('div');
      card.className = 'package-card';
      card.setAttribute('data-package-handle', pkg.handle);
      card.innerHTML = `
        <img class="package-image" src="${pkg.image}" alt="${t(pkg.titleKey)}" width="500" height="500">
        <input type="radio" name="package-selection" class="package-radio" value="${pkg.handle}">
        <p class="package-title">${t(pkg.titleKey)}</p>
      `;
      grid.appendChild(card);
    });
    if (this.state.selectedPackage) {
      const m = grid.querySelector(`[data-package-handle="${this.state.selectedPackage.handle}"]`);
      if (m) { m.classList.add('selected'); const r = m.querySelector('.package-radio'); if (r) r.checked = true; }
    }
    grid.querySelectorAll('.package-radio').forEach(radio => {
      radio.addEventListener('change', e => this.handlePackageSelection(e));
    });
    grid.querySelectorAll('.package-card').forEach(card => {
      card.addEventListener('click', () => {
        const radio = card.querySelector('.package-radio');
        if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
    this._initPackageCarousel();
  }

  _initPackageCarousel() {}

  populateOccasionDropdown() {
    const sel = this.container.querySelector('#occasion-select');
    if (!sel) return;
    sel.innerHTML = `<option value="" disabled selected>${t('select_occasion')}</option>`;
    OCCASIONS_LIST.forEach(occ => {
      const opt = document.createElement('option');
      opt.value       = occ.value;
      opt.textContent = t(occ.labelKey);
      sel.appendChild(opt);
    });
  }

renderSleeveSection(occasionValue) {
  const container = this.container.querySelector('.sleeve-selection-container');
  if (!container) return;

  const isCustom = occasionValue === 'custom_occasion';
  const designs = occasionValue
    ? (SLEEVE_DESIGNS[occasionValue] || [])
    : (SLEEVE_DESIGNS.default || []);
  const showPresets = !isCustom && designs.length > 0;

  const cardWrapper = container.querySelector('.sleeve-card-wrapper');
  if (cardWrapper) cardWrapper.style.display = 'flex';

  this._renderSleevePresets(container, showPresets, designs);
  this._renderSleeveCustomText(container, isCustom);
  this.updateStep4ContinueButton();
}

// ADD these new methods after renderSleeveSection:

_renderSleevePresets(container, show, designs) {
  let section = container.querySelector('.sleeve-presets-section');
  if (!section) {
    section = document.createElement('div');
    section.className = 'sleeve-presets-section';
    const cardWrapper = container.querySelector('.sleeve-card-wrapper');
    if (cardWrapper) {
      container.insertBefore(section, cardWrapper);
    } else {
      container.appendChild(section);
    }
  }

  if (!show) {
    section.style.display = 'none';
    section.innerHTML = '';
    return;
  }

  section.style.display = 'block';
  section.innerHTML = `
    <p class="sleeve-presets-label">${t('sleeve_designs')}</p>
    <div class="sleeve-presets-grid"></div>
    <p class="sleeve-or-divider">${t('sleeve_or_upload')}</p>
  `;

  const grid = section.querySelector('.sleeve-presets-grid');

  designs.forEach(d => {
    const card = document.createElement('div');
    card.className = 'sleeve-preset-card';
    if (this.state.selectedSleeveDesignId === d.id) card.classList.add('selected');
    card.dataset.designId = d.id;
    card.dataset.designImage = d.image;

    const img = document.createElement('img');
    img.alt = t(d.labelKey);
    img.loading = 'eager';

    const label = document.createElement('span');
    label.textContent = t(d.labelKey);

    img.style.minHeight = '120px';
    img.style.background = '#e8e0d0';

    img.onload = () => {
      img.style.minHeight = '';
      img.style.background = '';
    };

    img.onerror = () => {
      setTimeout(() => {
        const retry = new Image();
        retry.onload = () => { img.src = d.image; };
        retry.onerror = () => {
          img.style.minHeight = '80px';
          img.style.background = '#e8e0d0';
          img.alt = `${t(d.labelKey)} (failed to load)`;
          label.textContent = `${t(d.labelKey)} ⚠`;
        };
        retry.src = d.image + '?retry=' + Date.now();
      }, 500);
    };

    img.src = d.image;

    card.appendChild(img);
    card.appendChild(label);

    card.addEventListener('click', () => {
      grid.querySelectorAll('.sleeve-preset-card').forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');

      this.state.selectedSleeveDesignId = d.id;
      this.state.sleeveImage = null;
      this.resetSleevePreview();
      this._showPresetInPreview(d.image);
      this.updateStep4ContinueButton();
      this.saveState();
    });

    grid.appendChild(card);
  });

  if (this.state.selectedSleeveDesignId && !this.state.sleeveImage) {
    const selected = designs.find(d => d.id === this.state.selectedSleeveDesignId);
    if (selected) this._showPresetInPreview(selected.image);
  }
}

_showPresetInPreview(imageUrl) {
  const inner = this.container.querySelector('.sleeve-card-inner');
  if (!inner) return;

  inner.innerHTML = `
    <img class="sleeve-preview-img" src="" alt="Sleeve preview"
         style="min-height:120px;background:#e8e0d0;">
    <button class="sleeve-remove-btn" type="button">${t('remove')}</button>
  `;

  const img = inner.querySelector('.sleeve-preview-img');

  img.onload = () => {
    img.style.minHeight = '';
    img.style.background = '';
  };

  img.onerror = () => {
    setTimeout(() => {
      img.src = imageUrl + '?retry=' + Date.now();
    }, 500);
  };

  img.src = imageUrl;

  inner.querySelector('.sleeve-remove-btn').addEventListener('click', () => {
    this.state.selectedSleeveDesignId = null;
    this.state.sleeveImage = null;
    this.saveState();
    this.resetSleevePreview();
    this.container.querySelectorAll('.sleeve-preset-card').forEach(c => c.classList.remove('selected'));
    this.updateStep4ContinueButton();
  });
}

_renderSleeveCustomText(container, show) {
  let section = container.querySelector('.sleeve-custom-text-section');
  if (!section) {
    section = document.createElement('div');
    section.className = 'sleeve-custom-text-section';
    container.appendChild(section);
  }

  if (!show) {
    section.style.display = 'none';
    this.state.sleeveCustomText = '';
    return;
  }

  section.style.display = 'block';
  section.innerHTML = `
    <label class="sleeve-custom-text-label" for="sleeve-custom-text-input">
      ${t('sleeve_custom_text_label')}
    </label>
    <div class="sleeve-custom-text-row">
      <input
        type="text"
        id="sleeve-custom-text-input"
        class="sleeve-custom-text-input"
        placeholder="${t('sleeve_custom_text_placeholder')}"
        value="${this._escapeHtml(this.state.sleeveCustomText || '')}"
      >
      <button class="sleeve-custom-save-btn" type="button">${t('sleeve_custom_save')}</button>
    </div>
    <span class="sleeve-custom-saved-msg" style="display:none">${t('sleeve_custom_saved')}</span>
  `;

  const input = section.querySelector('.sleeve-custom-text-input');
  const saveBtn = section.querySelector('.sleeve-custom-save-btn');
  const savedMsg = section.querySelector('.sleeve-custom-saved-msg');

  input.addEventListener('input', () => {
    this.state.sleeveCustomText = input.value;
    this.updateStep4ContinueButton();
    this.saveState();
  });

  saveBtn.addEventListener('click', () => {
    this.state.sleeveCustomText = input.value;
    this.saveState();
    savedMsg.style.display = 'block';
    saveBtn.textContent = t('sleeve_custom_saved');
    setTimeout(() => {
      savedMsg.style.display = 'none';
      saveBtn.textContent = t('sleeve_custom_save');
    }, 1800);
  });
}

_escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

attachSleeveListeners() {
  const occasionSelect = this.container.querySelector('#occasion-select');
  if (!occasionSelect) return;

  if (this._occasionAbort) this._occasionAbort.abort();
  this._occasionAbort = new AbortController();

 if (!this.state.selectedOccasion) {
  const nonCustom = OCCASIONS_LIST.filter(o => o.value !== 'custom_occasion');
  const random = nonCustom[Math.floor(Math.random() * nonCustom.length)];
  this.state.selectedOccasion = random.value;
  this.state.selectedOccasionLabel = t(random.labelKey);
  this.saveState();
}
occasionSelect.value = this.state.selectedOccasion;

  occasionSelect.addEventListener('change', e => {
    const val = e.target.value;
    const label = e.target.options[e.target.selectedIndex].text;

    this.state.selectedOccasion = val;
    this.state.selectedOccasionLabel = label;
    this.state.selectedSleeveDesignId = null;
    this.state.sleeveImage = null;
    this.state.sleeveCustomText = '';
    this.state.selectedPackage = null;
    this.state.customPackageText = '';

    this.resetSleevePreview();
    this.renderSleeveSection(val);
    this.saveState();
  }, { signal: this._occasionAbort.signal });

  this.renderSleeveSection(this.state.selectedOccasion || null);

  if (this.state.sleeveImage) {
    this.renderSleevePreview(this.state.sleeveImage);
  }
}

  async handleSleeveUpload(e) {
  const file = e.target.files[0];
  e.target.value = ''; // reset early so the same file can be retried after a fix

  // Optional: show a lightweight loading state on the upload button
  const uploadBtn = this.container.querySelector('.sleeve-upload-btn');
  const originalText = uploadBtn?.textContent;
  if (uploadBtn) {
    uploadBtn.disabled = true;
    uploadBtn.textContent = 'Validating...';
  }

  try {
    const result = await validateImageFile(file);

    if (!result.ok) {
      this.showSleeveUploadError(result.message);
      return;
    }

    this.state.sleeveImage = result.dataUrl;
    this.state.selectedSleeveDesignId = null;
    this.container.querySelectorAll('.sleeve-preset-card')
      .forEach(c => c.classList.remove('selected'));
    this.saveState();
    this.renderSleevePreview(result.dataUrl);
    this.updateStep4ContinueButton();
    this.clearSleeveUploadError();
  } finally {
    if (uploadBtn) {
      uploadBtn.disabled = false;
      uploadBtn.textContent = originalText;
    }
  }
}

showSleeveUploadError(message) {
  let errEl = this.container.querySelector('.sleeve-upload-error');
  if (!errEl) {
    errEl = document.createElement('p');
    errEl.className = 'sleeve-upload-error';
    errEl.style.cssText = 'color:#dc2626;font-size:13px;text-align:center;margin-top:10px;';
    const wrapper = this.container.querySelector('.sleeve-card-wrapper');
    if (wrapper) wrapper.parentNode.insertBefore(errEl, wrapper.nextSibling);
  }
  errEl.textContent = message;
  errEl.style.display = 'block';
}

clearSleeveUploadError() {
  const errEl = this.container.querySelector('.sleeve-upload-error');
  if (errEl) errEl.style.display = 'none';
}

  renderSleevePreview(base64) {
    const inner = this.container.querySelector('.sleeve-card-inner');
    if (!inner) return;
    inner.innerHTML = `
      <img class="sleeve-preview-img" src="${base64}" alt="Sleeve preview">
      <button class="sleeve-remove-btn" type="button">✕ Remove</button>
    `;
    inner.querySelector('.sleeve-remove-btn').addEventListener('click', () => {
      this.state.sleeveImage = null;
      this.saveState();
      this.resetSleevePreview();
      this.updateStep4ContinueButton();
    });
  }

  resetSleevePreview() {
    const inner = this.container.querySelector('.sleeve-card-inner');
    if (!inner) return;
    inner.innerHTML = `
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" stroke="#ccc" stroke-width="1.2">
        <rect x="8" y="8" width="40" height="40" rx="4"/>
        <path d="M8 20h40M20 20v28"/>
        <circle cx="38" cy="14" r="4" fill="#ccc" stroke="none"/>
      </svg>
      <p class="sleeve-card-label">${t('sleeve_preview')}</p>
    `;
  }

  attachEventListeners() {
    this.container.querySelectorAll('.wizard-continue').forEach(btn => {
      btn.addEventListener('click', e => this.handleContinue(e));
    });

    const backButton = this.container.querySelector('.wizard-back');
    if (backButton) backButton.addEventListener('click', e => this.goToStep(parseInt(e.target.dataset.prevStep)));

    this.container.querySelectorAll('.product-checkbox').forEach(cb => {
      cb.addEventListener('change', e => this.handleProductSelection(e));
    });

    const occasionSelect = this.container.querySelector('#occasion-select');
    if (occasionSelect) {
      occasionSelect.addEventListener('change', e => {
        this.state.selectedOccasion      = e.target.value;
        this.state.selectedOccasionLabel = e.target.options[e.target.selectedIndex].text;
        this.state.selectedPackage       = null;
        this.state.customPackageText     = '';
        this.renderPackagesForOccasion(e.target.value);
        this.saveState();
      });
    }

    const submitBtn = this.container.querySelector('.wizard-submit');
    if (submitBtn) submitBtn.addEventListener('click', () => this.handleSubmit());

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.slideLeft());
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.slideRight());

    this.container.addEventListener('click', e => {
      const uploadBtn = e.target.closest('.sleeve-upload-btn');
      if (!uploadBtn) return;
      e.preventDefault();
      let fi = this.container.querySelector('.sleeve-file-input');
      if (!fi) {
        fi = document.createElement('input');
        fi.type = 'file';
        fi.accept = 'image/*';
        fi.className = 'sleeve-file-input';
        fi.style.display = 'none';
        this.container.appendChild(fi);
        fi.addEventListener('change', ev => this.handleSleeveUpload(ev));
      }
      fi.click();
    });

    const addProductBtn = this.container.querySelector('.add-product-btn');
    if (addProductBtn) addProductBtn.addEventListener('click', () => this.openAddProductModal());
  }

  updateContinueButton() {
    if (this.continueButton) {
      const dis = this.state.selectedProducts.length === 0;
      this.continueButton.disabled = dis;
      this.continueButton.classList.toggle('disabled', dis);
    }
  }

  updateStep2ContinueButton() {
    const btn = this.container.querySelector('[data-step="2"] .wizard-continue');
    if (!btn) return;
    const ok = this.state.selectedProducts.length > 0 &&
               this.state.selectedProducts.every(p => p.variants.length > 0);
    btn.disabled = !ok;
    btn.classList.toggle('disabled', !ok);
  }

  updateStep3ContinueButton() {
    const btn = this.container.querySelector('[data-step="3"] .wizard-continue');
    if (!btn) return;
    const ok = !!this.state.selectedPackage;
    btn.disabled = !ok;
    btn.classList.toggle('disabled', !ok);
  }

  updateStep4ContinueButton() {
    const btn = this.container.querySelector('[data-step="4"] .wizard-continue');
    if (!btn) return;

    const hasOccasion = !!this.state.selectedOccasion;
    let sleeveReady   = false;

    if (this.state.selectedOccasion === 'custom_occasion') {
      sleeveReady = !!(this.state.sleeveImage && this.state.sleeveCustomText?.trim());
    } else if (this.state.selectedOccasion) {
      sleeveReady = !!(this.state.selectedSleeveDesignId || this.state.sleeveImage);
    } else {
      sleeveReady = false;
    }

    const ok = hasOccasion && sleeveReady;
    btn.disabled = !ok;
    btn.classList.toggle('disabled', !ok);
  }

  slideLeft()  { if (this.state.sliderIndex > 0) { this.state.sliderIndex--; this.updateSlider(); } }
  slideRight() {
    const cards = this.sliderGrid.querySelectorAll('.product-card');
    const max   = Math.max(0, cards.length - this.getVisibleCards());
    if (this.state.sliderIndex < max) { this.state.sliderIndex++; this.updateSlider(); }
  }
  getVisibleCards() {
    const w = this.container.querySelector('.product-slider-wrapper').offsetWidth;
    return Math.floor(w / 220);
  }
  updateSlider() {
    const cards = this.sliderGrid.querySelectorAll('.product-card');
    const cw    = cards[0] ? cards[0].offsetWidth : 220;
    this.sliderGrid.style.transform = `translateX(-${this.state.sliderIndex * (cw + 20)}px)`;
    this.updateSliderButtons();
  }
  updateSliderButtons() {
    const cards = this.sliderGrid.querySelectorAll('.product-card');
    const max   = Math.max(0, cards.length - this.getVisibleCards());
    if (this.prevButton) this.prevButton.disabled = this.state.sliderIndex === 0;
    if (this.nextButton) this.nextButton.disabled = this.state.sliderIndex >= max;
  }

handleContinue(e) {
  const nextStep = parseInt(e.target.dataset.nextStep);

  if (this.state.currentStep === 1 && this.state.selectedProducts.length === 0) {
    alert(t('err_select_product'));
    return;
  }

  if (nextStep === 2) this.renderSelectedProducts();

  this.goToStep(nextStep);
}

goToStep(n) {
  this.container.querySelectorAll('.wizard-step').forEach(s => { s.classList.add('hidden'); s.style.display = 'none'; });
  const target = this.container.querySelector(`[data-step="${n}"]`);
  if (!target) return;
  target.classList.remove('hidden');
  target.style.display = 'block';
  this.state.currentStep = n;
  this.saveState();

  const subtitle = document.querySelector('.wizard-subtitle');
  if (subtitle && STEP_SUBTITLES[n]) subtitle.textContent = STEP_SUBTITLES[n];

  const backCont = this.container.querySelector('.wizard-back-container');
  const backBtn  = this.container.querySelector('.wizard-back');
  if (n > 1) { backCont.style.display = 'block'; backBtn.dataset.prevStep = n - 1; }
  else        { backCont.style.display = 'none'; }

  this.updateBottomLeftDot(n);

if (n === 2) {
  requestAnimationFrame(() => this.updateStep2ContinueButton());
}

if (n === 3) {
  requestAnimationFrame(() => {
    this.updateStep3ContinueButton();
    this._initPackageCarousel();
  });
}

  // Initialize Step 4 sleeve UI whenever we land on it
  if (n === 4) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.attachSleeveListeners();
        this.updateStep4ContinueButton();
      });
    });
  }

  // Initialize Step 5 form validation whenever we land on it
  if (n === 5) {
    requestAnimationFrame(() => {
      this.setupFormValidation();
      this.checkFormValidity();
    });
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });
}

  updateBottomLeftDot(n) {
    const dot = this.container.querySelector('.wizard-header .corner-dot.bottom-left');
    if (dot) dot.style.display = (window.innerWidth > 768 && n > 1) ? 'none' : 'block';
  }

  handleProductSelection(e) {
    const card   = e.target.closest('.product-card');
    const handle = card.dataset.productHandle;
    if (e.target.checked) {
      if (!this.state.selectedProducts.find(p => p.handle === handle))
        this.state.selectedProducts.push({ handle, title: t(handle), variants: [] });
      card.classList.add('selected');
    } else {
      this.state.selectedProducts = this.state.selectedProducts.filter(p => p.handle !== handle);
      card.classList.remove('selected');
      this.state.currentCustomProductIndex = 0;
    }
    this.updateContinueButton();
    this.saveState();
  }

  handlePackageSelection(e) {
    this.container.querySelectorAll('.package-card').forEach(c => c.classList.remove('selected'));
    const card = e.target.closest('.package-card');
    if (card && e.target.checked) {
      card.classList.add('selected');
      this.state.selectedPackage = { handle: card.dataset.packageHandle, title: card.querySelector('.package-title').textContent };
      this.updateStep3ContinueButton();
      this.saveState();
    }
  }

  renderPackagesForOccasion(occasionValue) {
    this.renderPackages();
  }

  renderSelectedProducts() {
    const listContainer = this.container.querySelector('.selected-products-list');
    if (!listContainer) return;
    listContainer.innerHTML = '';

    const stickerSide  = this.container.querySelector('.sticker-type-side');
    const variantSide  = this.container.querySelector('.variant-selection-side');

    if (this.state.selectedProducts.length === 0) {
      listContainer.innerHTML = `<p style="text-align:center;color:#999;">${t('no_products')}</p>`;
      if (stickerSide) stickerSide.style.display = 'none';
      if (variantSide) variantSide.style.gridColumn = '1 / -1';
      this.updateTotalPrice();
      return;
    }

    this.state.selectedProducts.forEach(product => {
      const pd = PRODUCTS_DATA.find(p => p.handle === product.handle);
      if (!pd) return;
      const div = document.createElement('div');
      div.className = 'selected-product-item';
      div.innerHTML = `
        <img src="${pd.image}" alt="${t(product.handle)}" class="product-thumbnail">
        <div class="product-info-wrapper">
          <h4>${t(product.handle)}</h4>
          <div class="variant-dropdown-wrapper">
            <button class="variant-dropdown-btn" data-handle="${product.handle}">
              <span>${t('select_scents')}</span>
              <svg width="12" height="8" viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 1L6 6L11 1" stroke-linecap="round"/>
              </svg>
            </button>
            <div class="variant-dropdown-menu" data-handle="${product.handle}">
              ${pd.variants.map(v => `
                <label class="variant-option">
                  <input type="checkbox" value="${v.value}" class="variant-checkbox"
                    ${product.variants.some(sv => sv.value === v.value) ? 'checked' : ''}>
                  <span class="variant-checkbox-custom"></span>
                  <span>${t(v.value)}</span>
                </label>
              `).join('')}
            </div>
          </div>
          <div class="selected-variants-list" data-handle="${product.handle}">
            ${this.renderSelectedVariants(product, pd)}
          </div>
        </div>
      `;
      listContainer.appendChild(div);
    });

    this.attachVariantDropdownListeners();
    this.setupDropdownCloseListener();

    if (this.hasCustomStickerProducts()) {
      if (stickerSide) stickerSide.style.display = 'flex';
      if (variantSide) variantSide.style.gridColumn = '';
      this.setupStickerTypeListeners();
      this.renderOriginalView();
    } else {
      if (stickerSide) stickerSide.style.display = 'none';
      if (variantSide) variantSide.style.gridColumn = '1 / -1';
    }

    this.updateTotalPrice();
    this.updateStep2ContinueButton();
    this.saveState();
  }

  hasCustomStickerProducts() {
    return this.state.selectedProducts.some(p => PRODUCTS_DATA.find(pd => pd.handle === p.handle)?.supportsCustomSticker);
  }

  getCustomStickerProducts() {
    return this.state.selectedProducts.filter(p => PRODUCTS_DATA.find(pd => pd.handle === p.handle)?.supportsCustomSticker);
  }

  renderSelectedVariants(product, pd) {
    return product.variants.map(v => {
      const vd = pd.variants.find(x => x.value === v.value);
      if (!vd) return '';
      return `
        <div class="variant-quantity-item">
          <span class="variant-name">${t(v.value)}</span>
          <div class="quantity-controls">
            <span>${t('quantity')}</span>
            <button class="quantity-btn minus" data-handle="${product.handle}" data-variant="${v.value}">−</button>
            <input type="number" class="quantity-input" value="${v.quantity}" min="10" step="10"
              data-handle="${product.handle}" data-variant="${v.value}">
            <button class="quantity-btn plus" data-handle="${product.handle}" data-variant="${v.value}">+</button>
          </div>
        </div>
      `;
    }).filter(Boolean).join('');
  }

  setupStickerTypeListeners() {
    document.querySelectorAll('.sticker-type-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.sticker-type-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        if (btn.dataset.type === 'original') {
          document.querySelector('.sticker-original-view')?.classList.add('active');
          document.querySelector('.sticker-custom-view')?.classList.remove('active');
          this.renderOriginalView();
        } else {
          document.querySelector('.sticker-original-view')?.classList.remove('active');
          document.querySelector('.sticker-custom-view')?.classList.add('active');
          this.renderCustomView();
        }
      });
    });

    const prev = document.querySelector('.carousel-prev');
    const next = document.querySelector('.carousel-next');
    if (prev) prev.addEventListener('click', () => this.previousProduct());
    if (next) next.addEventListener('click', () => this.nextProduct());

    const customizeBtn = document.querySelector('.sticker-customize-btn');
    if (customizeBtn) customizeBtn.addEventListener('click', () => this.saveCustomization());
  }

  renderOriginalView() {
    const grid = document.querySelector('.sticker-products-grid');
    if (!grid) return;
    grid.innerHTML = '';
    this.getCustomStickerProducts().forEach(p => {
      const pd  = PRODUCTS_DATA.find(x => x.handle === p.handle);
      const div = document.createElement('div');
      div.className = 'sticker-original-product';
      div.innerHTML = `<img src="${pd.image}" alt="${pd.alt}">`;
      grid.appendChild(div);
    });
  }

  renderCustomView() {
    const cp = this.getCustomStickerProducts();
    if (this.state.currentCustomProductIndex < 0 || this.state.currentCustomProductIndex >= cp.length)
      this.state.currentCustomProductIndex = 0;
    this.updateCustomViewDisplay();
  }

  updateCustomViewDisplay() {
    const cp = this.getCustomStickerProducts();
    if (this.state.currentCustomProductIndex >= cp.length)
      this.state.currentCustomProductIndex = Math.max(0, cp.length - 1);
    const product = cp[this.state.currentCustomProductIndex];
    if (!product) return;
    const pd  = PRODUCTS_DATA.find(x => x.handle === product.handle);
    const img  = document.querySelector('.sticker-product-image');
    const name = document.querySelector('.sticker-product-name');
    const inp  = document.querySelector('.sticker-custom-text');
    if (img)  img.src         = pd.customLabelImage;
    if (name) name.textContent = t(product.handle);
    if (inp)  inp.value        = product.customText || '';
    this.drawStickerPreview(product.customText || '');
    const prev = document.querySelector('.carousel-prev');
    const next = document.querySelector('.carousel-next');
    if (prev) prev.disabled = this.state.currentCustomProductIndex === 0;
    if (next) next.disabled = this.state.currentCustomProductIndex === cp.length - 1;
  }

  previousProduct() {
    if (this.state.currentCustomProductIndex > 0) { this.state.currentCustomProductIndex--; this.updateCustomViewDisplay(); }
  }
  nextProduct() {
    const cp = this.getCustomStickerProducts();
    if (this.state.currentCustomProductIndex < cp.length - 1) { this.state.currentCustomProductIndex++; this.updateCustomViewDisplay(); }
  }

  loadImage(src) {
    if (!this._imageCache) this._imageCache = {};
    if (this._imageCache[src]) return this._imageCache[src];
    this._imageCache[src] = new Promise((res, rej) => {
      const img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = () => res(img); img.onerror = rej; img.src = src;
    });
    return this._imageCache[src];
  }

  wrapAndFitText(ctx, text, maxW, maxH, maxFS, fontFamily) {
    let fs = maxFS;
    while (fs > 6) {
      ctx.font = `${fs}px ${fontFamily}`;
      const words = text.split(/\s+/);
      const lines = []; let cur = words[0] || '';
      for (let i = 1; i < words.length; i++) {
        const test = cur + ' ' + words[i];
        if (ctx.measureText(test).width > maxW) { lines.push(cur); cur = words[i]; }
        else cur = test;
      }
      lines.push(cur);
      if (lines.some(l => ctx.measureText(l).width > maxW)) { fs--; continue; }
      const lh = fs * 1.3;
      if (lines.length * lh <= maxH) return { lines, fontSize: fs, lineHeight: lh };
      fs--;
    }
    ctx.font = `6px ${fontFamily}`;
    return { lines: [text], fontSize: 6, lineHeight: 8 };
  }

  drawStickerPreview(text) {
    const canvas = document.querySelector('.sticker-product-canvas');
    if (!canvas) return;
    const cp      = this.getCustomStickerProducts();
    const product = cp[this.state.currentCustomProductIndex];
    if (!product) return;
    const pd = PRODUCTS_DATA.find(x => x.handle === product.handle);
    if (!pd?.safeZone) return;
    const sz = pd.safeZone;
    this.loadImage(pd.customLabelImage).then(img => {
      canvas.width  = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const cw = canvas.width, ch = canvas.height;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, cw, ch);
      ctx.drawImage(img, 0, 0, cw, ch);
      if (!text?.trim()) { this.showCanvas(); return; }
      const zoneW = sz.width * cw, zoneH = sz.height * ch;
      const cx = sz.centerX * cw, cy = sz.centerY * ch;
      const { lines, fontSize, lineHeight } = this.wrapAndFitText(
        ctx, text.trim(), zoneH * 0.92, zoneW * 0.88,
        Math.floor(zoneW * 0.25), sz.fontFamily
      );
      ctx.save();
      ctx.translate(cx, cy); ctx.rotate(sz.rotation);
      ctx.fillStyle = sz.textColor; ctx.font = `${fontSize}px ${sz.fontFamily}`;
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      const totalH = lines.length * lineHeight;
      const startY = -(totalH / 2) + lineHeight / 2;
      lines.forEach((l, i) => ctx.fillText(l, 0, startY + i * lineHeight));
      ctx.restore();
      this.showCanvas();
    }).catch(e => console.error('Mockup load error:', e));
  }

  showCanvas() {
    const img    = document.querySelector('.sticker-product-image');
    const canvas = document.querySelector('.sticker-product-canvas');
    const frame  = document.querySelector('.sticker-product-frame');
    if (img) img.classList.add('hidden');
    if (canvas && frame) {
      const fw = frame.clientWidth - 4, fh = frame.clientHeight - 4;
      const cw = canvas.width || 1, ch = canvas.height || 1;
      const sc = Math.min(fw / cw, fh / ch);
      canvas.style.width  = Math.floor(cw * sc) + 'px';
      canvas.style.height = Math.floor(ch * sc) + 'px';
      canvas.classList.add('active');
    }
  }

  hideCanvas() {
    const img    = document.querySelector('.sticker-product-image');
    const canvas = document.querySelector('.sticker-product-canvas');
    if (img) img.classList.remove('hidden');
    if (canvas) { canvas.classList.remove('active'); canvas.style.width = ''; canvas.style.height = ''; }
  }

  saveCustomization() {
    const inp = document.querySelector('.sticker-custom-text');
    const cp  = this.getCustomStickerProducts();
    const p   = cp[this.state.currentCustomProductIndex];
    if (p && inp) {
      p.customText = inp.value;
      this.saveState();
      this.drawStickerPreview(inp.value);
      const btn = document.querySelector('.sticker-customize-btn');
      btn.textContent = t('saved');
      setTimeout(() => { btn.textContent = t('customize'); }, 1500);
    }
  }

  handleQuantityInput(handle, variantValue, newValue) {
    const product = this.state.selectedProducts.find(p => p.handle === handle);
    if (!product) return;
    const variant = product.variants.find(v => v.value === variantValue);
    if (!variant) return;
    variant.quantity = Math.max(10, parseInt(newValue) || 0);
    const pd  = PRODUCTS_DATA.find(p => p.handle === handle);
    const vl  = document.querySelector(`.selected-variants-list[data-handle="${handle}"]`);
    if (vl) { vl.innerHTML = this.renderSelectedVariants(product, pd); this.attachVariantDropdownListeners(); }
    this.updateTotalPrice(); this.updateStep2ContinueButton(); this.saveState();
  }

  updateTotalPrice() {
    const total = this.state.selectedProducts.reduce((sum, product) => {
      const qty  = product.variants.reduce((s, v) => s + v.quantity, 0);
      const unit = getUnitPrice(product.handle, qty);
      if (unit !== null) return sum + qty * unit;
      const pd   = PRODUCTS_DATA.find(p => p.handle === product.handle);
      if (!pd) return sum;
      return sum + product.variants.reduce((s, v) => {
        const vd = pd.variants.find(x => x.value === v.value);
        return vd ? s + v.quantity * parseFloat(vd.price || 0) : s;
      }, 0);
    }, 0);
    const el = this.container.querySelector('.total-price');
    if (el) el.textContent = `KD ${total.toFixed(3)}`;
  }

  positionDropdown(btn) {
    const menu = btn.nextElementSibling;
    if (!menu) return;
    const r = btn.getBoundingClientRect();
    menu.classList.toggle('dropdown-flip', window.innerHeight - r.bottom < 300 && r.top > 300);
  }

  attachVariantDropdownListeners() {
    document.querySelectorAll('.variant-dropdown-btn').forEach(old => {
      const fresh = old.cloneNode(true);
      old.parentNode.replaceChild(fresh, old);
    });
    document.querySelectorAll('.variant-dropdown-btn').forEach(btn => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        const menu = document.querySelector(`.variant-dropdown-menu[data-handle="${btn.dataset.handle}"]`);
        document.querySelectorAll('.variant-dropdown-menu').forEach(m => { if (m !== menu) m.classList.remove('active'); });
        menu.classList.toggle('active');
        if (menu.classList.contains('active')) this.positionDropdown(btn);
      });
    });
    document.querySelectorAll('.variant-checkbox').forEach(cb => {
      cb.addEventListener('change', e => {
        const menu = e.target.closest('.variant-dropdown-menu');
        this.handleVariantSelection(menu.dataset.handle, e.target.value, e.target.checked);
      });
    });
    document.querySelectorAll('.quantity-btn').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        this.handleVariantQuantityChange(btn.dataset.handle, btn.dataset.variant, btn.classList.contains('plus'));
      });
    });
    document.querySelectorAll('.quantity-input').forEach(inp => {
      inp.addEventListener('blur',    e => this.handleQuantityInput(e.target.dataset.handle, e.target.dataset.variant, e.target.value));
      inp.addEventListener('keypress', e => { if (e.key === 'Enter') e.target.blur(); });
    });
  }

  setupDropdownCloseListener() {
    if (this.dropdownCloseListenerAdded) return;
    document.addEventListener('click', e => {
      if (!e.target.closest('.variant-dropdown-wrapper'))
        document.querySelectorAll('.variant-dropdown-menu').forEach(m => m.classList.remove('active'));
    });
    this.dropdownCloseListenerAdded = true;
  }

  handleVariantSelection(handle, variantValue, isChecked) {
    const product = this.state.selectedProducts.find(p => p.handle === handle);
    if (!product) return;
    if (isChecked) {
      if (!product.variants.find(v => v.value === variantValue))
        product.variants.push({ value: variantValue, quantity: 10 });
    } else {
      product.variants = product.variants.filter(v => v.value !== variantValue);
      if (product.variants.length === 0) {
        this.state.selectedProducts = this.state.selectedProducts.filter(p => p.handle !== handle);
        this.state.currentCustomProductIndex = 0;
        this.renderSelectedProducts();
        if (document.querySelector('.sticker-custom-view.active'))   this.updateCustomViewDisplay();
        if (document.querySelector('.sticker-original-view.active')) this.renderOriginalView();
        this.updateTotalPrice();
        return;
      }
    }
    const pd = PRODUCTS_DATA.find(p => p.handle === handle);
    const vl = document.querySelector(`.selected-variants-list[data-handle="${handle}"]`);
    if (vl) { vl.innerHTML = this.renderSelectedVariants(product, pd); this.attachVariantDropdownListeners(); }
    this.updateTotalPrice(); this.updateStep2ContinueButton(); this.saveState();
  }

  handleVariantQuantityChange(handle, variantValue, isIncrease) {
    const product = this.state.selectedProducts.find(p => p.handle === handle);
    if (!product) return;
    const variant = product.variants.find(v => v.value === variantValue);
    if (!variant) return;
    if (isIncrease) {
      variant.quantity += 10;
    } else {
      variant.quantity -= 10;
      if (variant.quantity <= 0) {
        product.variants = product.variants.filter(v => v.value !== variantValue);
        if (product.variants.length === 0) {
          this.state.selectedProducts = this.state.selectedProducts.filter(p => p.handle !== handle);
          this.state.currentCustomProductIndex = 0;
          this.renderSelectedProducts();
          if (document.querySelector('.sticker-custom-view.active'))   this.updateCustomViewDisplay();
          if (document.querySelector('.sticker-original-view.active')) this.renderOriginalView();
          this.updateTotalPrice(); this.saveState();
          return;
        }
      } else {
        variant.quantity = Math.max(10, variant.quantity);
      }
    }
    const pd = PRODUCTS_DATA.find(p => p.handle === handle);
    if (!pd) return;
    const vl = document.querySelector(`.selected-variants-list[data-handle="${handle}"]`);
    if (vl) { vl.innerHTML = this.renderSelectedVariants(product, pd); this.attachVariantDropdownListeners(); }
    this.updateTotalPrice(); this.updateStep2ContinueButton(); this.saveState();
  }

  checkFormValidity() {
    const form      = this.container.querySelector('.booking-form');
    const submitBtn = this.container.querySelector('.wizard-submit');
    if (!form || !submitBtn) return;
    const ok = ['#customer-name','#phone-number','#email','#delivery-address','#delivery-date','#delivery-store']
      .every(s => form.querySelector(s)?.value?.trim());
    submitBtn.disabled = !ok;
    submitBtn.classList.toggle('disabled', !ok);
  }

  setupFormValidation() {
    const form = this.container.querySelector('.booking-form');
    if (!form) return;
    form.querySelectorAll('input, select').forEach(el => {
      el.addEventListener('input',  () => this.checkFormValidity());
      el.addEventListener('change', () => this.checkFormValidity());
    });
  }

  getFormData() {
    const form = this.container.querySelector('.booking-form');
    if (!form) return null;
    return {
      customerName:    form.querySelector('#customer-name')?.value    || '',
      customerPhone:   form.querySelector('#phone-number')?.value     || '',
      customerEmail:   form.querySelector('#email')?.value            || '',
      deliveryAddress: form.querySelector('#delivery-address')?.value || '',
      deliveryDate:    form.querySelector('#delivery-date')?.value     || '',
      store:           form.querySelector('#delivery-store')?.value   || ''
    };
  }

  validateForm() {
    const f = this.getFormData();
    const errors = [];
    if (!f.customerName   || f.customerName.trim().length < 2)       errors.push(t('err_name'));
    if (!f.customerEmail  || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.customerEmail)) errors.push(t('err_email'));
    if (!f.customerPhone  || f.customerPhone.trim().length < 8)      errors.push(t('err_phone'));
    if (!f.deliveryAddress || f.deliveryAddress.trim().length < 5)   errors.push(t('err_address'));
    if (!f.deliveryDate)                                               errors.push(t('err_date'));
    return errors;
  }

  openAddProductModal() {
    const modal = document.getElementById('addProductModal');
    if (!modal) return;
    this.renderModalProducts();
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closeAddProductModal() {
    const modal = document.getElementById('addProductModal');
    if (!modal) return;
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  renderModalProducts() {
    const grid = document.querySelector('.modal-product-grid');
    if (!grid) return;
    grid.innerHTML = '';
    PRODUCTS_DATA.forEach(product => {
      const isSel = this.state.selectedProducts.some(p => p.handle === product.handle);
      const card  = document.createElement('div');
      card.className = `modal-product-card ${isSel ? 'selected' : ''}`;
      card.setAttribute('data-product-handle', product.handle);
      card.innerHTML = `
        <img src="${product.image}" alt="${t(product.handle)}">
        <p>${t(product.handle)}</p>
        <input type="checkbox" class="modal-product-checkbox" ${isSel ? 'checked' : ''}>
      `;
      card.addEventListener('click', () => {
        const cb = card.querySelector('.modal-product-checkbox');
        cb.checked = !cb.checked;
        card.classList.toggle('selected', cb.checked);
        this.updateModalAddButton();
      });
      grid.appendChild(card);
    });
    this.updateModalAddButton();
    const cancel = document.querySelector('.modal-cancel-btn'); if (cancel) cancel.onclick = () => this.closeAddProductModal();
    const add    = document.querySelector('.modal-add-btn');    if (add)    add.onclick    = () => this.addProductsFromModal();
    const close  = document.querySelector('.add-product-modal .modal-close');   if (close)   close.onclick   = () => this.closeAddProductModal();
    const overlay= document.querySelector('.add-product-modal .modal-overlay'); if (overlay) overlay.onclick = () => this.closeAddProductModal();
  }

  updateModalAddButton() {
    const btn = document.querySelector('.modal-add-btn');
    if (btn) btn.disabled = document.querySelectorAll('.modal-product-checkbox:checked').length === 0;
  }

  addProductsFromModal() {
    document.querySelectorAll('.modal-product-checkbox:checked').forEach(cb => {
      const handle = cb.closest('.modal-product-card').dataset.productHandle;
      if (!this.state.selectedProducts.find(p => p.handle === handle))
        this.state.selectedProducts.push({ handle, title: t(handle), quantity: 1, variants: [] });
    });
    document.querySelectorAll('.modal-product-checkbox:not(:checked)').forEach(cb => {
      const handle = cb.closest('.modal-product-card').dataset.productHandle;
      this.state.selectedProducts = this.state.selectedProducts.filter(p => p.handle !== handle);
    });
    this.state.currentCustomProductIndex = 0;
    this.renderSelectedProducts();
    if (document.querySelector('.sticker-custom-view.active'))   this.updateCustomViewDisplay();
    if (document.querySelector('.sticker-original-view.active')) this.renderOriginalView();
    this.closeAddProductModal();
  }

  async handleSubmit() {
    if (this.state.isSubmitting) return;
    const errors = this.validateForm();
    if (errors.length) { alert(t('err_fix_errors') + errors.join('\n')); return; }

    const formData = this.getFormData();
    const allowed  = ['eau-de-parfum', 'home-spray'];
    const filtered = this.state.selectedProducts.filter(p => allowed.includes(p.handle));
    if (!filtered.length && this.state.selectedProducts.length) {
      alert(t('err_product_filter')); this.state.isSubmitting = false; return;
    }

    const transformedProducts = filtered.map(product => {
      const pd  = PRODUCTS_DATA.find(p => p.handle === product.handle);
      const qty = product.variants.reduce((s, v) => s + v.quantity, 0);
      return {
        handle: product.handle, title: product.title,
        customText: product.customText || null, quantity: qty,
        variants: product.variants.map(v => {
          const vd = pd.variants.find(x => x.value === v.value);
          return { value: v.value, label: vd.label, sku: vd.sku, quantity: v.quantity };
        })
      };
    });

    let sleeveImagePayload = this.state.sleeveImage || null;
    if (!sleeveImagePayload && this.state.selectedSleeveDesignId) {
      const occ     = this.state.selectedOccasion;
      const designs = SLEEVE_DESIGNS[occ] || [];
      const design  = designs.find(d => d.id === this.state.selectedSleeveDesignId);
      sleeveImagePayload = design?.image || null;
    }

    const payload = {
      customerName:      formData.customerName,
      customerEmail:     formData.customerEmail,
      customerPhone:     formData.customerPhone,
      deliveryAddress:   formData.deliveryAddress,
      deliveryDate:      formData.deliveryDate,
      store:             formData.store,
      occasion:          this.state.selectedOccasionLabel || this.state.selectedOccasion || '',
      packageType:       this.state.selectedPackage?.title || '',
      customPackageText: this.state.customPackageText || null,
      sleeveImage:       sleeveImagePayload,
      sleeveCustomText:  this.state.sleeveCustomText || null,
      products:          transformedProducts,
      totalPrice:        this.container.querySelector('.total-price')?.textContent || ''
    };

    console.log('GIVEAWAY BOOKING SUBMISSION\n===================================');
    console.log('PAYLOAD:', JSON.stringify(payload, null, 2));

    const submitBtn       = this.container.querySelector('.wizard-submit');
    submitBtn.textContent = t('submitting');
    submitBtn.disabled    = true;
    this.state.isSubmitting = true;

    try {
      const response = await fetch(`${GIVEAWAY_API_URL}/api/giveaway/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const text = await response.text();
      let result;
      try { result = JSON.parse(text); }
      catch (e) { throw new Error('Server returned invalid JSON: ' + text.substring(0, 100)); }

      if (!response.ok) {
        const msg = result.error || result.errors?.join(', ') || result.message || result.details || 'Unknown server error';
        throw new Error(`Server error (${response.status}): ${msg}`);
      }

      if (result.success) {
        const modal     = document.getElementById('bookingModal');
        const modalBody = modal?.querySelector('.modal-body');
        if (modalBody) {
          modalBody.innerHTML = `
            <svg width="87" height="86" viewBox="0 0 87 86" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="87" height="86" rx="43" fill="#F2EDE0"/>
              <path d="M38.7503 50.2953L32.6778 44.2228C32.3505 43.8955 31.9068 43.7117 31.444 43.7117C30.9813 43.7117 30.5375 43.8955 30.2103 44.2228C29.883 44.55 29.6992 44.9938 29.6992 45.4565C29.6992 45.6856 29.7443 45.9125 29.832 46.1242C29.9197 46.3359 30.0482 46.5282 30.2103 46.6903L37.5253 54.0053C38.2078 54.6878 39.3103 54.6878 39.9928 54.0053L58.5078 35.4903C58.835 35.163 59.0188 34.7193 59.0188 34.2565C59.0188 33.7938 58.835 33.35 58.5078 33.0228C58.1805 32.6955 57.7367 32.5117 57.274 32.5117C56.8113 32.5117 56.3675 32.6955 56.0403 33.0228L38.7503 50.2953Z" fill="#CB4B17"/>
            </svg>
            <h2>${t('success_title')}</h2>
            <p>${t('success_body')}</p>
            <p style="font-size:18px;font-weight:bold;color:#e85d04;">${t('booking_id')} ${result.bookingId}</p>
            <p style="color:#666;font-size:14px;">${t('save_id')}</p>
            <button class="modal-btn" type="button">${t('close')}</button>
          `;
          const closeBtn = modalBody.querySelector('.modal-btn');
          if (closeBtn) closeBtn.addEventListener('click', () => {
            modal.classList.remove('active');
            document.body.style.overflow = '';
            this.resetWizard();
          });
        }
        if (modal) { modal.classList.add('active'); document.body.style.overflow = 'hidden'; }
      } else {
        throw new Error(result.error || 'Failed to submit booking');
      }
    } catch (err) {
      console.error('SUBMISSION ERROR:', err.message, err);
      alert(t('err_submit') + '\n\n' + err.message);
    } finally {
      submitBtn.textContent   = t('create_booking');
      submitBtn.disabled      = false;
      this.state.isSubmitting = false;
    }
  }

  resetWizard() {
    this.clearState();
    this.state = {
      selectedProducts: [], selectedPackage: null,
      selectedOccasion: null, selectedOccasionLabel: null,
      customPackageText: '', selectedSleeveDesignId: null,
      sleeveImage: null, sleeveCustomText: '',
      currentStep: 1, sliderIndex: 0, packageCarouselIndex: 0,
      isSubmitting: false, currentCustomProductIndex: 0
    };
    const form = this.container.querySelector('.booking-form');
    if (form) form.reset();
    this.container.querySelectorAll('.product-checkbox').forEach(cb => {
      cb.checked = false; cb.closest('.product-card')?.classList.remove('selected');
    });
    const sel = this.container.querySelector('#occasion-select');
    if (sel) sel.value = '';
    const pkgGrid = this.container.querySelector('.package-grid');
    if (pkgGrid) pkgGrid.innerHTML = '';
    const customPkg = this.container.querySelector('.custom-package-section');
    if (customPkg) customPkg.style.display = 'none';
    this.goToStep(1);
    this.updateContinueButton();
  }
}

// ==========================================
// INIT
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  const wiz = document.querySelector('.giveaway-wizard');
  if (wiz) window.wizardInstance = new GiveawayWizard(wiz);
});

window.addEventListener('resize', () => {
  if (window.wizardInstance) {
    window.wizardInstance.updateSliderButtons();
    window.wizardInstance.updateBottomLeftDot(window.wizardInstance.state.currentStep);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const modal   = document.getElementById('bookingModal');
  const close   = modal?.querySelector('.modal-close');
  const overlay = modal?.querySelector('.modal-overlay');
  function closeModal() { if (modal) { modal.classList.remove('active'); document.body.style.overflow = ''; } }
  if (close)   close.addEventListener('click',   closeModal);
  if (overlay) overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal?.classList.contains('active')) closeModal(); });
  window.openBookingModal  = function () { if (modal) { modal.classList.add('active'); document.body.style.overflow = 'hidden'; } };
  window.closeBookingModal = closeModal;
});